/**
 * Enum encapsulating various relationships that a user can have with a modern group
 */ export var UserGroupRelation = /*#__PURE__*/ function(UserGroupRelation) {
    /**
     * User is not a member of the group.
     */ UserGroupRelation["NonMember"] = "nonMember";
    /**
     * User is a member of the group.
     */ UserGroupRelation["Member"] = "member";
    /**
     * User is the owner of the group.
     */ UserGroupRelation["Owner"] = "owner";
    return UserGroupRelation;
}({});
